import { useSubComponentsFactory } from './factories/useSubComponentsFactory';
import { PostPreviewStyles } from './PostPreview.styles';
import type { PostPreviewProps } from './types';

export function PostPreview(props: PostPreviewProps) {
	const { variant, size, showPlatformIcon } = props;
	const mainStyles = PostPreviewStyles({ size });

	const { header, body, footer } = useSubComponentsFactory(props);

	return (
		<section data-testid={`post-preview-${variant}`} className={mainStyles}>
			{showPlatformIcon && <div>Icon</div>}
			{header}
			{body}
			{footer}
		</section>
	);
}
